exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-headline[data-v-5725c3c0] {\n  background-color: #FFFFFF;\n  text-align: center;\n  padding: 24px 16px;\n}\n.page-headline-contents[data-v-5725c3c0] {\n    margin: auto;\n    max-width: 1040px;\n}\n", ""]);
